/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {resetPastAttemptsByAppToken} from '../api'

export const useMutationResetPastAttemptsByAppToken = createReactQueryMutationHook('resetPastAttemptsByAppToken', resetPastAttemptsByAppToken)
